import React from 'react';
import EllipsisText from 'react-ellipsis-text';
import onClickOutside from 'react-onclickoutside';
import { Link } from 'react-router-dom';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './styles.css';
import BasicNavLinkButton from '../../../../../../components/BasicNavLinkButton';
import HorizontalLoader from '../../../../../../components/HorizontalLoader';
import ENDPOINT from '../../../../../../constants/endpoints';
import ROUTE from '../../../../../../constants/route';
import LinkBuilder from '../../../../../../helpers/link-builder';
import {get, token} from '../../../../../../services/api';

class InboxDropdown extends React.Component {
  constructor(props) {
    super(props);
    this._source = token.source();
    this.state = {
      isFetching: false,
      grid: {
        perPage: 0,
        page: 0,
        rows: [],
        rowsCount: 0,
        pagesCount: 0,
      },
    };
  }

  componentWillUnmount() {
    this._source.cancel();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.toggled && this.props.toggled !== prevProps.toggled) {
      this.setState({
        grid: {
          perPage: 0,
          page: 0,
          rows: [],
          rowsCount: 0,
          pagesCount: 0,
        },
      });
    }

    if (
      this.props.toggled &&
      !this.state.isFetching &&
      !this.state.grid.rows.length &&
      this.props.toggled !== prevProps.toggled
    ) {
      this.fetchGrid();
    }
  }
  viewAllMessages = () => {
    this.props.toggleFunc('outsideInbox');
  };

  clickHandler = e => {
    e.stopPropagation();
    if (Number(this.props.messageCounter) > 0) {
      this.props.toggleFunc('inbox');
    } else {
      this.props.history.push(ROUTE.INBOX);
    }
  };

  handleClickOutside = () => {
    this.props.toggleFunc('outsideInbox');
  };

  handleScroll = event => {
    event.persist();
    this.loadData(event.target);
  };

  loadData = debounce(target => {
    const {
      isFetching,
      grid: { page, pagesCount },
    } = this.state;
    const nextPage = page + 1;
    if (
      target.scrollTop + 10 >= target.scrollHeight - target.offsetHeight &&
      pagesCount > nextPage &&
      !isFetching
    ) {
      this.fetchGrid({ page: nextPage });
    }
  }, 100);

  fetchGrid = (params = {}) => {
    this.setState(
      () => ({
        isFetching: true,
      }),
      () =>
        get(
          ENDPOINT.COLLECTION.INBOX_UNREAD,
          params,
          {
            handleSuccess: gridData => {
              const nextRows = cloneDeep(gridData.rows);
              this.setState({
                isFetching: false,
                grid: {
                  ...gridData,
                  rows: [...this.state.grid.rows, ...nextRows],
                },
              });
            },
          },
          { cancelToken: this._source.token }
        )
    );
  };

  render() {
    const { messageCounter } = this.props;
    const {
      isFetching,
      grid: { rows, rowsCount },
    } = this.state;

    const subMenuStatus = this.props.toggled ? 'flex' : 'none';
    const subMenuStyles = {
      display: subMenuStatus,
    };

    return (
      <div className="inbox-dropdown" onScroll={this.handleScroll}>
        <div className="inbox-dropdown__icon" onClick={this.clickHandler} />

        {messageCounter > 0 && (
          <div
            className="inbox-dropdown__submenu ignore-react-onclickoutside"
            style={subMenuStyles}
          >
            <div className="inbox-dropdown__submenu-content">
              {Number(rowsCount) === 0 ? (
                !isFetching && <div>No unread messages</div>
              ) : (
                <ul className="inbox-dropdown__submenu-list">
                  {rows.map(
                    ({
                      MessageID,
                      PictureUrl,
                      FromName,
                      Subject,
                      Date,
                      ShortText,
                      MessageFolderID,
                    }) => (
                      <li
                        className="inbox-dropdown__submenu-list-item"
                        key={MessageID}
                      >
                        <Link
                          to={{
                            pathname: ROUTE.INBOX,
                            state: {
                              initialParams: {
                                message: MessageID,
                                folder: MessageFolderID,
                              },
                            },
                          }}
                          onClick={this.handleClickOutside}
                          className="inbox-dropdown__submenu-list-item-link"
                        >
                          <div className="inbox-dropdown__submenu-list-item-avatar">
                            <div className="inbox-dropdown__submenu-list-item-photo">
                              <img
                                src={LinkBuilder.getCandidatePictureSizeLink(
                                  PictureUrl,
                                  '40x40'
                                )}
                                alt={FromName}
                                className="inbox-dropdown__submenu-list-item-img"
                              />
                            </div>
                          </div>
                          <div className="inbox-dropdown__submenu-list-item-content">
                            <h5 className="inbox-dropdown__submenu-list-item-name">
                              {FromName}
                            </h5>
                            <span className="inbox-dropdown__submenu-list-item-subject">
                              {Subject}
                            </span>
                            <span className="inbox-dropdown__submenu-list-item-date">
                              {Date}
                            </span>
                            <p className="inbox-dropdown__submenu-list-item-text">
                              <EllipsisText text={ShortText} length={80} />
                            </p>
                          </div>
                        </Link>
                      </li>
                    )
                  )}
                </ul>
              )}
              {isFetching && (
                <div style={{ paddingTop: '35px' }}>
                  <HorizontalLoader
                    loaderStyles={{
                      left: '50%',
                      top: '10px',
                      transform: 'translate(-50%, 0)',
                    }}
                  />
                </div>
              )}
            </div>
            <div className="inbox-dropdown__view-all-messages">
              <BasicNavLinkButton
                btnWidth={298}
                btnHeight={35}
                btnFontSize={12}
                btnFontWeight={600}
                btnText="View All Messages"
                btnArrow={false}
                btnBg="#fff"
                btnHoverBg="#f40"
                to={ROUTE.INBOX}
                onClick={this.viewAllMessages}
              />
            </div>
          </div>
        )}

        {!!messageCounter && (
          <span className="inbox-dropdown__counter">{messageCounter}</span>
        )}
      </div>
    );
  }
}

InboxDropdown.propTypes = {
  toggled: PropTypes.bool.isRequired,
  toggleFunc: PropTypes.func.isRequired,
  messageCounter: PropTypes.number,
};

export default withRouter(onClickOutside(InboxDropdown));
